import './../libs/gin-tonic/app/storybook.scss';
import { DragScrollComponent } from './../libs/gin-tonic/components/drag-scroll/component';
import { HistoryComponent } from './components/history/history';
import { MultiFilterComponent } from './components/multi-filter/index';
import './main.scss';

import { factory } from './../libs/gin-tonic/helpers/compiler';

import { CounterComponent } from '../libs/gin-tonic/components/counter/component';
import { GallerySliderComponent } from '../libs/gin-tonic/components/gallery-slider/component';
import { IntersectComponent } from '../libs/gin-tonic/components/intersect/component';
import { MixitComponent } from '../libs/gin-tonic/components/mixitup/component';
import { ModalGalleryComponent } from '../libs/gin-tonic/components/modal-gallery/component';
import { ModalComponent } from '../libs/gin-tonic/components/modal/component';
import { IFramePlayerComponent } from '../libs/gin-tonic/components/player/component';
import { MagicScrollFadeInComponent } from '../libs/gin-tonic/components/scroll-magic/fade-in';
import { MagicScrollSlideHorizontalComponent } from '../libs/gin-tonic/components/scroll-magic/slide-horizontal';
import { MagicScrollZoomComponent } from '../libs/gin-tonic/components/scroll-magic/zoom';
import { SelectComponent } from '../libs/gin-tonic/components/select/component';
import { StickyComponent } from '../libs/gin-tonic/components/sticky';
import { SwiperComponent } from '../libs/gin-tonic/components/swiper/component';
import { TabsComponent } from '../libs/gin-tonic/components/tabs/component';
import { CollapseComponent } from './../libs/gin-tonic/components/collapse/component';
import { MagicScrollBoxComponent } from './../libs/gin-tonic/components/scroll-magic/box';
import { TweenEffectComponent } from './../libs/gin-tonic/components/tween-effect/component';
import { CaseSliderComponent } from './components/case-slider/case-slider';
import { ClockComponent } from './components/clock/clock';
import { CookieRenewComponent } from './components/cookie/cookie';
import { FilterComponent } from './components/filter';
import { HamburgerComponent } from './components/hamburger/hamburger';
import { HeroComponent } from './components/hero/hero';
import { LetsTalkComponent } from './components/lets-talk/lets-talk';
import { LetsTalkRTEComponent } from './components/lets-talk/lets-talk-rte';
import { ListsComponent } from './components/lists/lists';
import { LogoListsComponent } from './components/lists/logo-list';
import { LoadMoreComponent } from './components/load-more';
import { ImgModalComponent } from './components/modal/img-modal';
import { PlayerModalComponent } from './components/modal/modal';
import { MagicScrollToggleVisibilityComponent } from './components/nav/toggle-visibility';
import { SlidersComponent } from './components/sliders/sliders';
import { MagicScrollStackComponent } from './components/stacks/stacks';
import { StatementComponent } from './components/statement/statement';
import { HighlightComponent } from './components/text/highlight';
import { TeamComponent } from './pages/team/team';

export function loadComponents(...components: any[]): void {
	factory(components)(document.body);
}

loadComponents(
	CaseSliderComponent,
	ClockComponent,
	CollapseComponent,
	CounterComponent,
	CookieRenewComponent,
	DragScrollComponent,
	FilterComponent,
	TweenEffectComponent,
	HamburgerComponent,
	HeroComponent,
	HighlightComponent,
	HistoryComponent,
	IntersectComponent,
	ImgModalComponent,
	ListsComponent,
	LetsTalkComponent,
	LetsTalkRTEComponent,
	LogoListsComponent,
	LoadMoreComponent,
	MagicScrollBoxComponent,
	MagicScrollFadeInComponent,
	MagicScrollSlideHorizontalComponent,
	MagicScrollStackComponent,
	MagicScrollZoomComponent,
	MagicScrollToggleVisibilityComponent,
	MixitComponent,
	ModalGalleryComponent,
	MultiFilterComponent,
	IFramePlayerComponent,
	PlayerModalComponent,
	ModalComponent,
	GallerySliderComponent,
	SelectComponent,
	SlidersComponent,
	StatementComponent,
	StickyComponent,
	SwiperComponent,
	TabsComponent,
	TeamComponent
);
